// extracted by mini-css-extract-plugin
export var logo = "app-icon-module--logo--8378a";